import { useNavigate, useLocation } from "react-router-dom";

export const useBackNavigation = (fallbackUrl: string = "/") => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = (e: React.MouseEvent) => {
    e.preventDefault();
    if (window.history.length > 2 || location.key !== "default") {
      navigate(-1);
    } else {
      navigate(fallbackUrl);
    }
  };

  return handleBack;
};
